import { render, staticRenderFns } from "./sort-controller.vue?vue&type=template&id=641128d9&scoped=true"
import script from "./sort-controller.vue?vue&type=script&lang=js"
export * from "./sort-controller.vue?vue&type=script&lang=js"
import style0 from "./sort-controller.vue?vue&type=style&index=0&id=641128d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641128d9",
  null
  
)

export default component.exports